import { Html5Qrcode } from "html5-qrcode"

export class FieldCamera {
  constructor(elementId) {
    this._elementId = elementId
    this._instance = null
    this._facingMode = "environment"
  }

  async start(onScan) {
    if (this._instance) return
    this._instance = new Html5Qrcode(this._elementId)
    await this._instance.start(
      { facingMode: this._facingMode },
      { fps: 10, qrbox: { width: 250, height: 150 } },
      onScan,
      () => {}
    )
  }

  async stop() {
    if (!this._instance) return
    try { await this._instance.stop() } catch (_) {}
    this._instance = null
  }

  async flip() {
    await this.stop()
    this._facingMode = this._facingMode === "environment" ? "user" : "environment"
  }

  get facingMode() { return this._facingMode }
}
